<template>
    <div class="main-table-body">
        <p><span>*</span>单位规格</p>
		<div style="text-align:left">
			<el-button type="primary" plain class="fx-big-btn" size='small' @click="add" :disabled="tableData.length >= 1" v-if="editDisable">添加</el-button>
			<el-button type="primary" plain class="fx-big-btn" size='small' @click="pullUnit" v-if="editDisable && sourceflag && clddock ===1">拉取单位</el-button>
			<span style="margin-left: 10px">说明：极速订卖家后台，每个商品只能使用1个单位</span>
		</div>

		<div class="table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				size='mini'
				border
				stripe
				:height="tableHeight"
			>
				<template v-for="(item, index) in cols" >
					<el-table-column
						v-if="item.show"
						:key="`col_${index}`"
						:prop="item.prop"
						:label="item.label"
						:min-width="item.width"
						:align="item.align">
					</el-table-column>
				</template>
				<el-table-column label="默认单位" width="200" align="center">
					<template slot-scope="scope">
						<el-radio :disabled="!editDisable" v-model="radio" :label="scope.$index" @change.native="updateDefaultUnit(scope)">&nbsp;</el-radio>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center" v-if="editDisable">
					<template slot-scope="scope">
						<el-button type='text' size="mini" icon="el-icon-delete" @click="delItem(scope.row)">删除</el-button>
						<el-button type='text' size="mini" icon="el-icon-search" @click="editItem(scope.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog
			title="新增单位"
			:visible.sync="dialogVisible"
			class="dialog-title"
			width="500px"
			:close-on-click-modal="false"
			><UnitDialog :visible.sync="dialogVisible" :itemData='itemData' v-if="dialogVisible" @confirmHandle='confirmHandle'/>
		</el-dialog>
    </div>
</template>

<script>
import { cols } from '@/js/business/goodsManagementCols/attributesInfoCols/mainTableCols'
import UnitDialog from '@/components/goodsManagement/attributesInfo/Dialog'
export default {
	name: 'mainTable',
	components: {
		UnitDialog
	},
	props: {
		editDisable: {
			type: Boolean,
			default: true
		}
	},
	data () {
		return {
			clddock: null,
			itemId: '',
			id: '',
			sourceflag: false,
			tableHeight: '100%',
			cols: cols,
			tableData: [],
			dialogVisible: false,
			radio: 2,
			itemData: {}
		}
	},
	created () {
		this.getGoodsInfo()
		this.getGoodsUnitInfo()
	},
	methods: {
		getGoodsInfo () {
			let params = {
				id: sessionStorage.getItem('goodsid'),
				bcId: '0',
				scId: '0',
				goodsName: '',
				saleState: 2,
				auditState: 4,
				page: 1,
				size: 20,
				hiddenFlag: +sessionStorage.getItem('goodHiddenFlag'),
				order: 1,
				orderKey: '',
				unitFlag: -1,
				sourceflag: -1
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getGoodsInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					console.log(res)
					this.clddock = res.data.clddock
					let data = res.data.recordList[0]
					this.id = data.id
					this.itemId = data.itemId
					this.sourceflag = data.sourceflag
				}
			})
		},
		pullUnit () {
			let params = {
				id: this.id,
				itemId: this.itemId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/dockcld/saveNewUnit`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('拉取成功')
					this.getGoodsUnitInfo()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getTableData () {
			return this.tableData.length
		},
		add () {
			this.dialogVisible = true
			this.itemData = {}
		},
		getGoodsUnitInfo () {
			let params = {
				goodsId: sessionStorage.getItem('goodsid')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getGoodsUnitInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					res.data.forEach(item => {
						item.defaultprice = this.$fxUtils.toFixedSHW(item.defaultprice, 2)
						item.standardweight = this.$fxUtils.toFixedSHW(item.standardweight, 3)
					})
					this.tableData = res.data
					this.radio = res.data.findIndex(item => {
						return item.defaultunitflag === 1
					})
				}
			})
		},
		confirmHandle () {
			this.dialogVisible = false
			this.getGoodsUnitInfo()
		},
		editItem (data) {
			this.itemData = data
			this.dialogVisible = true
		},
		delItem (data) {
			this.$confirm('是否删除该单位？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					id: data.id
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/goods/delGoodsUnit`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功！')
						this.getGoodsUnitInfo()
					} else {
						this.$message.error(res.msg)
						this.getGoodsUnitInfo()
					}
				})
			}).catch(() => {})
		},
		updateDefaultUnit (data) {
			this.$confirm('是否更换默认单位？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					id: data.row.id,
					goodsId: sessionStorage.getItem('goodsid')
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/goods/updateDefaultUnit`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('默认单位更换成功！')
						this.getGoodsUnitInfo()
					} else {
						if (res.code === 1) {
							this.$alert(res.msg, {
								dangerouslyUseHTMLString: true
							})
						} else {
							this.$message.error(res.msg)
						}
						this.getGoodsUnitInfo()
					}
				}).catch(() => {
					this.getGoodsUnitInfo()
				})
			}).catch(() => {
				this.getGoodsUnitInfo()
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table-body {
    display: flex
    flex-direction column
	flex: 1
	p {
		height: 20px
		text-align: left
		line-height 20px
		font-size 16px
		border-left 4px solid var(--fx-primary-color)
		padding-left 8px
		margin 20px 0
		font-weight 700
		span {
			color: #FE3B39
			margin-right 6px
		}
	}
	.table-box {
		height: 300px
		padding: 10px 0
		overflow-y: auto;
		.grid-content {
			/deep/.el-radio__label {
				padding 0
			}
		}
	}
}
</style>
<style lang="stylus">
.main-table-body {
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
	}
}
</style>
